
/* styles */
require("!!vue-style-loader!css-loader!./../../vue-loader/lib/style-rewriter?id=data-v-473fd92e!sass-loader!./../../vue-loader/lib/selector?type=styles&index=0!./UiSelect.vue")

var Component = require("!./../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./../../vue-loader/lib/selector?type=script&index=0!./UiSelect.vue"),
  /* template */
  require("!!./../../vue-loader/lib/template-compiler?id=data-v-473fd92e!./../../vue-loader/lib/selector?type=template&index=0!./UiSelect.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/keen-ui/src/UiSelect.vue
// module id = 505
// module chunks = 22